// helpers
import mapWhiteLabelHeader from "@/helpers/mapWhiteLabelHeader";
import getLocalizationCode from "@/helpers/getLocalizationCode";
import { buildUrl } from "./helpers";

const isServer = typeof window === "undefined";

async function getFetchHeaders(): Promise<Record<string, string>> {
  let localizationCode = null;

  if (isServer) {
    const { headers } = await import("next/headers");

    const headersList = headers();
    
    localizationCode = (headersList.get("x-localization") || "") || "uk";
  } else {
    const localizationCodeDraft = getLocalizationCode(window.location.pathname);
    localizationCode = localizationCodeDraft ? localizationCodeDraft : "uk";
  }

  return {
    "geographic-region": localizationCode.toUpperCase(),
    ...mapWhiteLabelHeader(),
  };
}

interface INextFetchOptions extends RequestInit {
  params?: Record<string, unknown>;
}

export default async function customFetch(
  url: string,
  initOptions?: INextFetchOptions
) {
  const headers = await getFetchHeaders();
  const { params, ...options } = initOptions || {};
  const fetchUrl = buildUrl(`${process.env.NEXT_PUBLIC_APP_API_URL}${url}`, params);
  
  const data = await fetch(fetchUrl, {
    ...options || {},
    next: {
      revalidate: 1200,
      ...(options?.next || {}),
    },
    headers: {
      ...headers,
      ...(options?.headers || {}),
    }
  });
  
  return data.status === 200 ? data.json() : data;
}
